import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EMPLOYEEASSESSMENTDETAIL,
  DELETE_EMPLOYEEASSESSMENTDETAIL,
  UPDATE_EMPLOYEEASSESSMENTDETAIL,
  ADD_NEW_EMPLOYEEASSESSMENTDETAIL,
} from "./actionType";

import {
  getEmployeeAssessmentDetailSuccess,
  getEmployeeAssessmentDetailFail,
  deleteEmployeeAssessmentDetailSuccess,
  deleteEmployeeAssessmentDetailFail,
  updateEmployeeAssessmentDetailSuccess,
  updateEmployeeAssessmentDetailFail,
  addEmployeeAssessmentDetailSuccess,
  addEmployeeAssessmentDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEmployeeAssessmentDetailApi,
  getEmployeeAssessmentDetailApi,
  updateEmployeeAssessmentDetailApi,
  deleteEmployeeAssessmentDetailApi,
  addNewEmployeeAssessmentDetailApi
} from "../../helpers/backend_helper";

function* getEmployeeAssessmentDetail({ payload: employeeAssessmentDetail }) {
  try {
    const response = yield call(getEmployeeAssessmentDetailApi, employeeAssessmentDetail);
    yield put(getEmployeeAssessmentDetailSuccess(GET_EMPLOYEEASSESSMENTDETAIL, response.data));
  } catch (error) {
    yield put(getEmployeeAssessmentDetailFail(GET_EMPLOYEEASSESSMENTDETAIL, error));
  }
}

function* onUpdateEmployeeAssessmentDetail({ payload: employeeAssessmentDetail }) {
  try {
    if (employeeAssessmentDetail.setApprove) {
      const response = yield call(approveEmployeeAssessmentDetailApi, employeeAssessmentDetail);
      yield put(updateEmployeeAssessmentDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateEmployeeAssessmentDetailApi, employeeAssessmentDetail);
      yield put(updateEmployeeAssessmentDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateEmployeeAssessmentDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployeeAssessmentDetail({ payload: employeeAssessmentDetail }) {
  try {
    const response = yield call(deleteEmployeeAssessmentDetailApi, employeeAssessmentDetail);
    yield put(deleteEmployeeAssessmentDetailSuccess({ employeeAssessmentDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeAssessmentDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployeeAssessmentDetail({ payload: employeeAssessmentDetail }) {
  try {
    const response = yield call(addNewEmployeeAssessmentDetailApi, employeeAssessmentDetail);
    yield put(addEmployeeAssessmentDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeAssessmentDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEmployeeAssessmentDetail() {
  yield takeEvery(GET_EMPLOYEEASSESSMENTDETAIL, getEmployeeAssessmentDetail);
}

export function* watchUpdateEmployeeAssessmentDetail() {
  yield takeEvery(UPDATE_EMPLOYEEASSESSMENTDETAIL, onUpdateEmployeeAssessmentDetail);
}

export function* watchDeleteEmployeeAssessmentDetail() {
  yield takeEvery(DELETE_EMPLOYEEASSESSMENTDETAIL, onDeleteEmployeeAssessmentDetail);
}

export function* watchAddNewEmployeeAssessmentDetail() {
  yield takeEvery(ADD_NEW_EMPLOYEEASSESSMENTDETAIL, onAddNewEmployeeAssessmentDetail);
}

function* employeeAssessmentDetailSaga() {
  yield all([
    fork(watchGetEmployeeAssessmentDetail),
    fork(watchDeleteEmployeeAssessmentDetail),
    fork(watchUpdateEmployeeAssessmentDetail),
    fork(watchAddNewEmployeeAssessmentDetail)
  ]);
}

export default employeeAssessmentDetailSaga;
